module.exports = __webpack_public_path__ + "static/media/2-menu.c0b1bfc5.svg";